import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';

export const WizardContentContainer = styled.section`
  display: flex;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  height: 400px;
`;

export const StyledImage = styled.img`
  max-width: 600px;
  max-height: 400px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 510px;
`;

export const TextDiv = styled.div<{ paragraphGap: string }>`
  padding: 0px 32px;
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 25.2px;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.paragraphGap};
  color: ${darkgrey};
`;

export const UnorderedList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
